import { useQuery } from "@tanstack/react-query";
import { validateSession } from "../api/authApi";

export const useAuthQuery = () => {
  return useQuery({
    queryKey: ['auth'],
    queryFn: validateSession,
    retry: false, // Don't retry on auth failures
    refetchOnWindowFocus: true, // Revalidate when user returns to tab
    staleTime: 1000 * 60 * 5, // 5 minutes (matches global config)
    cacheTime: 1000 * 60 * 60, // 1 hour (matches global config)
  });
};